import { render, staticRenderFns } from "./index.vue?vue&type=template&id=069abe70&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('069abe70')) {
      api.createRecord('069abe70', component.options)
    } else {
      api.reload('069abe70', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=069abe70&", function () {
      api.rerender('069abe70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/suppliers/reports/index.vue"
export default component.exports